import { render } from "./ResultPage.vue?vue&type=template&id=07e302a6"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"

import "./ResultPage.vue?vue&type=style&index=0&id=07e302a6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__